export const EAD_DIAGRAM_STANDARD_STORAGE_KEY = "ead.diagramStandard.v1";

export const DEFAULT_EAD_DIAGRAM_STANDARD = `Study the description of the Skill, and generate the Script for auto generating the EAD diagram. Simpler is often better.

Grammar:
- [Entity 1] represents an entity, such as [Project Template], [Run 1], [Run 2].
- .[Sub Entity 1] represents sub-entities, such as [Run 1].[Phase 1].
- <Action 1> represents an action step, such as <Open login form> or <Save skill>.
- --> represents transitions between [Entity] or .[Sub Entity] nodes.
- {Sample Condition} represents a condition or comment.

Keep the diagram simple: use at most 10 total entity nodes ([Entity] plus .[Sub Entity] combined) and at most 12 action nodes (<Action>). Prefer one clear main flow with only the most important steps.

Please analyze the Skill title and description to generate the EAD Script for the EAD Diagram for this skill.`;

/** Alias used by skill diagram generation (same as the global standard default). */
export const DEFAULT_EAD_DIAGRAM_GENERATE_PROMPT = DEFAULT_EAD_DIAGRAM_STANDARD;

export function loadStoredDiagramStandard(): string {
  try {
    const raw = localStorage.getItem(EAD_DIAGRAM_STANDARD_STORAGE_KEY);
    if (typeof raw === "string" && raw.trim()) return raw.trim();
  } catch {
    /* ignore */
  }
  return DEFAULT_EAD_DIAGRAM_STANDARD;
}

export function saveStoredDiagramStandard(text: string): void {
  try {
    localStorage.setItem(EAD_DIAGRAM_STANDARD_STORAGE_KEY, text.trim());
  } catch {
    /* ignore */
  }
}

export function resetStoredDiagramStandard(): void {
  try {
    localStorage.removeItem(EAD_DIAGRAM_STANDARD_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}

/** Effective global standard: operator override in localStorage, else built-in default. */
export function getEffectiveDiagramStandard(): string {
  return loadStoredDiagramStandard();
}

export function isUsingDefaultDiagramStandard(): boolean {
  try {
    const raw = localStorage.getItem(EAD_DIAGRAM_STANDARD_STORAGE_KEY);
    return !raw || !raw.trim();
  } catch {
    return true;
  }
}
